import { createContext, useContext, useState } from 'react';

const CarrinhoContext = createContext(null);

const passo = (produto) =>
  produto.passo_gramas && produto.unidade_medida === 'KG'
    ? produto.passo_gramas / 1000
    : 1;

export function CarrinhoProvider({ children }) {
  const [itens, setItens] = useState([]);
  const [empresaId, setEmpresaId] = useState(null);

  const adicionar = (produto, observacao) => {
    const step = passo(produto);
    setItens(prev => {
      const idx = prev.findIndex(i => i.id === produto.id);
      if (idx >= 0) {
        const novo = [...prev];
        novo[idx] = {
          ...novo[idx],
          quantidade: Math.round((novo[idx].quantidade + step) * 1000) / 1000,
          ...(observacao !== undefined ? { observacao } : {}),
        };
        return novo;
      }
      return [...prev, { ...produto, quantidade: step, observacao: observacao || null }];
    });
  };

  const atualizarObservacao = (produtoId, observacao) => {
    setItens(prev => prev.map(i => i.id === produtoId ? { ...i, observacao } : i));
  };

  const remover = (produtoId) => {
    setItens(prev => {
      const idx = prev.findIndex(i => i.id === produtoId);
      if (idx < 0) return prev;
      const item = prev[idx];
      const step = passo(item);
      const novo = [...prev];
      const novaQtd = Math.round((item.quantidade - step) * 1000) / 1000;
      if (novaQtd <= 0) novo.splice(idx, 1);
      else novo[idx] = { ...item, quantidade: novaQtd };
      return novo;
    });
  };

  const removerTudo = (produtoId) => setItens(prev => prev.filter(i => i.id !== produtoId));

  const limpar = () => { setItens([]); setEmpresaId(null); };

  const total = itens.reduce((acc, i) => acc + (i.preco_promocional || i.preco_venda) * i.quantidade, 0);

  // Para KG fracionado conta o produto como 1 item no badge; UN conta pela quantidade
  const totalItens = itens.reduce((acc, i) =>
    acc + (i.passo_gramas && i.unidade_medida === 'KG' ? 1 : i.quantidade), 0);

  return (
    <CarrinhoContext.Provider value={{
      itens, empresaId, setEmpresaId,
      adicionar, remover, removerTudo, limpar, atualizarObservacao,
      total, totalItens
    }}>
      {children}
    </CarrinhoContext.Provider>
  );
}

export const useCarrinho = () => useContext(CarrinhoContext);
